module.exports = __webpack_public_path__ + "static/media/deleteicon.ea84ee87.svg";